
import classNames from 'classnames/bind';
import { Box } from "@mui/system";
import { AgGridReact, CustomCellRendererProps } from "@ag-grid-community/react";
import { ColDef, ColGroupDef, GetRowIdFunc, GetRowIdParams, ModuleRegistry } from "@ag-grid-community/core";
import { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { CircularProgress, Stack, useTheme } from "@mui/material";
import { iconSetMaterial, themeAlpine } from 'ag-grid-community';

import './HoldingsListSymbolRealtime.scss';
import styles from './HoldingsListSymbolRealtime.module.scss';
import { produce } from "immer";
import ButtonElement from "@/views/elements/button/ButtonElement";
import ViewNumberFormat from "@/views/elements/Inputs/ViewNumberFormat";
import TypographyElement from '@/views/elements/typography/TypographyElement';
import SymbolVirtualRow from './SymbolVirtualRow';
import { useTranslation } from 'react-i18next';
import { STATUS_ACCOUNT } from '@/stores/dataStore/memoryStore/const/constIndex';

const cx = classNames.bind(styles);


ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    // AdvancedFilterModule,
    // ColumnsToolPanelModule,
    // ExcelExportModule,
    // FiltersToolPanelModule,
    // GridChartsModule,
    // MenuModule,
    // RangeSelectionModule,
    // RowGroupingModule,
    // SetFilterModule,
    // RichSelectModule,
    // StatusBarModule,
    // SparklinesModule,
]);

enum MODE_NUM { SHORT, FULL }

const numberFormatter = (value: any, type: MODE_NUM, log?: string) => {
    // console.log('ha_check_numberFormatter', { log, value })
    const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        maximumFractionDigits: 2,
    });
    if (type === MODE_NUM.SHORT) {
        if (isNaN(parseFloat(value))) {
            return value
        } else {
            return (value == null || value == undefined) ? "" : formatter.format(parseFloat(value) / 1000);
        }
    }
    return (value == null || value == undefined) ? "" : formatter.format(value);
};

interface Props {
    fullWidth?: boolean
    dataRaw: string[];
    dataReady: boolean;
    statusMaster: string
}

let sum = 0

const HoldingsListSymbolRealtime = ({
    dataRaw, dataReady, statusMaster, fullWidth
}: Props) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [rowData, setRowData] = useState<any[]>();
    const refData = useRef<any>(dataRaw)
    const [isPending, setIsPending] = useState<boolean>(false);

    const [, setRowVirtualVisible] = useState<[] | any[]>([]);



    const onGridReady = useCallback(() => {
        if (dataRaw && dataRaw.length !== 0) {
        }
        refData.current = dataRaw
        setRowData(dataRaw)
        // console.log('ha_check_onGridReady', refData.current)
    }, [dataRaw]);


    const calculatorSumMarket = (newInstrument?: any) => {
        sum = 0
        for (let index = 0; index < refData.current.length; index++) {
            const element: any = refData.current[index];
            const realtimeMarketPrice = newInstrument?.SB === element.symbol ? (newInstrument?.CP ? newInstrument?.CP : element.marketprice) : element.marketprice
            // console.log('ha_check_sum_sub', { symbol: element.symbol, realtimeMarketPrice, refData, newInstrument })
            sum += Number.parseFloat(realtimeMarketPrice) * Number.parseFloat(element.total_trade)
        }
        // console.log('ha_check_sum_fn', sum)
    }

    useEffect(() => {
        if (dataRaw && dataRaw.length !== 0) {
        }
        refData.current = dataRaw
        setRowData(dataRaw)
        // console.log('ha_check_onGridReady111', refData.current)
        calculatorSumMarket()
    }, [dataRaw])

    // useEffect(() => {
    //     if (gridRef.current) {
    //         alert(1)
    //         gridRef.current?.api?.refreshCells({ force: true }); // Refresh cells to reflect the new otherState value
    //     }
    // }, [sumTotalOnMarket])


    // useEffect(() => {
    // setRowVirtualVisible(getRenderedNodes() || [])
    // }, [dataSrc])

    const gridRef = useRef<AgGridReact>(null);

    const baseColumn: ColDef[] | ColGroupDef[] = [
        {
            headerName: t("copytrade.common.symbol"),
            field: "symbol",
            cellDataType: "text",
            minWidth: 100,
        },
        {
            headerName: t("copytrade.chart.holdingPortfolio.quantity"),
            field: "total_trade",
            cellDataType: "text",
            minWidth: 110,
            valueFormatter: (params) => {
                if (params.data.symbol === "Tiền") {
                    return ''
                }
                return numberFormatter(params.value, MODE_NUM.FULL).toString()
            },
        },
        {
            headerName: t("copytrade.chart.holdingPortfolio.costprice"),
            field: "costprice",
            cellDataType: "text",
            valueFormatter: (params) => {
                if (params.data.symbol === "Tiền") {
                    return ''
                }
                return numberFormatter(params.value, MODE_NUM.SHORT, params.data.symbol).toString()
            },
            minWidth: 110,
        },
        {
            headerName: t("copytrade.chart.holdingPortfolio.marketPrice"),
            field: "marketprice",
            cellDataType: "string",
            type: "leftAligned",
            minWidth: 160,
            valueFormatter: (params) => {
                if (params.data.symbol === "Tiền") {
                    return numberFormatter(params.data.total_trade, MODE_NUM.FULL).toString()
                }
                return numberFormatter(params.value, MODE_NUM.SHORT).toString()
            },
            // cellRenderer: 'agAnimateShowChangeCellRenderer',
        },
        {
            headerName: t("copytrade.chart.holdingPortfolio.dm"),
            cellDataType: "text",
            type: "centerAligned",
            minWidth: 90,
            valueGetter: (params) => {
                // console.log('ha_check_params', params.data.symbol, (params.data.total_trade * params.data.marketprice), sum)
                return `${((params.data.total_trade * params.data.marketprice) / sum * 100).toFixed(2)} %`
            },
        },
        {
            headerName: t('copytrade.common.ppnl'),
            cellDataType: "text",
            type: "centerAligned",
            minWidth: 100,
            valueGetter: (params) => {
                // console.log('ha_check_params', params.data.symbol, (params.data.total_trade * params.data.marketprice), sum)
                if (params.data.symbol === "Tiền") {
                    return ''
                }
                return ((params.data.total_trade * params.data.marketprice) - (params.data.total_trade * params.data.costprice)) / (params.data.total_trade * params.data.costprice) * 100;
            },
            cellRenderer: RenderPNL
        }
    ]

    const columnAction: ColDef | ColGroupDef = {
        headerName: "",
        minWidth: 100,
        // field: "action",
        cellRenderer: RenderActionSell,
    }

    const colDefs = useMemo<ColDef[] | ColGroupDef[]>(
        () => {
            if (statusMaster === STATUS_ACCOUNT.WC) {
                return baseColumn.concat(columnAction)
            } else {
                return baseColumn
            }
        },
        [statusMaster]
    );

    const defaultColDef: ColDef = useMemo(
        () => ({
            flex: 1,
            filter: false,
            resizable: false,
        }),
        []
    );

    const getRowId = useCallback<GetRowIdFunc>(
        ({ data }: GetRowIdParams) => {
            return data?.symbol
        },
        []
    );

    const getRenderedNodes = () => {
        const listNodeVisible = gridRef.current?.api?.getRenderedNodes() || []
        console.log('ha_check_listNodeVisible', listNodeVisible)
        return listNodeVisible.map(item => item.data).map((item: any) => item.symbol);
    };

    // const onBodyScroll = (event: BodyScrollEvent) => {
    //     setRowVirtualVisible(getRenderedNodes() || [])
    // }

    function copyObject(object: any) {
        // start with new object
        const newObject: any = {};
        // copy in the old values
        Object.keys(object).forEach((key) => {
            newObject[key] = object[key];
        });
        return newObject;
    }

    const applyTransactionAsyncRealtime = useCallback((newInstrument: any, log: string) => {
        newInstrument && newInstrument.CP && calculatorSumMarket(newInstrument)
        // console.log('ha_check_applyTransactionAsyncRealtime', { newInstrument, refData, log })
        if (isPending) {
            return;
        }
        const findData: any = refData?.current.find((item: any) => {
            return (item?.symbol && newInstrument?.SB && (item?.symbol === newInstrument?.SB))
        })

        if (findData) {
            // console.log('ha_check_applyTransactionAsyncRealtime1.1', { newInstrument, findData, log })

            const marketPrice = newInstrument?.CP === 0 ? findData.marketprice : newInstrument?.CP ?? findData.marketprice
            const newFindData = copyObject(findData);
            newFindData.marketprice = marketPrice
            // refData.current = [...refData.current, findData]

            const updatedData: any = produce(refData.current, (draft: any) => {
                const index = draft.findIndex((item: any) => item.symbol === newFindData.symbol);
                if (index !== -1) {
                    draft[index] = { ...draft[index], ...newFindData }; // Cập nhật phần tử tại vị trí tìm thấy
                }
            });
            // console.log('ha_check_newInstrument111', { marketPrice, newFindData, updatedData })

            for (let index = 0; index < updatedData.length; index++) {
                const element = updatedData[index];
                // console.log('ha_check_applyTransactionAsync', { element })

                element && gridRef.current?.api?.applyTransactionAsync(
                    { update: [element] }
                );
            }
            refData.current = updatedData
            // findData && gridRef.current?.api?.applyTransactionAsync(
            //     { update: [updatedData] }
            // );
        }

        // const rowNode = findData && gridRef.current?.api?.getRowNode(newInstrument.SB)!;
        // rowNode?.updateData(newInstrument);
    }, [])

    const myTheme = themeAlpine
        .withPart(iconSetMaterial)
        .withParams({
            accentColor: "#1989E4",
            backgroundColor: theme.palette.transparent,
            borderColor: theme.palette.table?.header,
            browserColorScheme: "dark",
            chromeBackgroundColor: "#31353B",
            fontFamily: "inherit",
            foregroundColor: theme.palette.text.primary,
            headerBackgroundColor: theme.palette.background.default,
            headerFontSize: 14,
            oddRowBackgroundColor: theme.palette.table?.odd,
        });

    function RenderActionSell(data: CustomCellRendererProps) {
        const dataRow = data.data
        if (dataRow?.symbol === 'Tiền') return null;
        return (
            <Stack direction={'row'} alignItems={'center'} height={'100%'}>
                <ButtonElement sx={{
                    backgroundColor: 'red',
                    height: '26px !important'
                }} onClick={() => alert(dataRow?.symbol)}> Bán</ButtonElement >
            </Stack>
        )
    }

    function RenderPNL(data: CustomCellRendererProps) {
        const dataRow = data.data
        // console.log('ha_check_RenderPNL', data)
        if (dataRow?.symbol === 'Tiền') return null;
        return (
            <ViewNumberFormat displayType="text" isPercentage={true} isCheckPNL={true} value={data?.value} />
        )
    }

    return (
        <div className={fullWidth === true ? cx("holding-list", "full-width") : cx("holding-list")}>
            <div className={cx("header-holding-list")}>
                <div className={cx("title-holding-list")}>
                    <TypographyElement FontWeightElement={700} FontSizeElement='16px' lineHeight='24px'>
                        {t("copytrade.chart.holdingPortfolio.title")}
                    </TypographyElement>
                </div>
            </div>

            <div className={cx("body-holding-list")}>
                <Box sx={{ width: '100%', height: '100%' }}>
                    <div style={{ height: '100%', marginTop: "10px" }} >
                        {dataReady === true ? <AgGridReact
                            theme={myTheme}
                            className="holding-list-table"
                            containerStyle={{ height: '100%', width: '100%' }}
                            ref={gridRef}
                            getRowId={getRowId}
                            onGridReady={onGridReady}
                            rowData={rowData}
                            columnDefs={colDefs}
                            defaultColDef={defaultColDef}
                            rowSelection={
                                {
                                    mode: 'singleRow',
                                    enableClickSelection: false,
                                    checkboxes: false,
                                }
                            }
                            suppressAggFuncInHeader
                            groupDefaultExpanded={-1}
                            suppressClickEdit={true}
                            suppressCellFocus={true}
                            suppressMaxRenderedRowRestriction={true}
                            suppressRowDrag={true}
                            suppressMoveWhenRowDragging={true}
                            suppressMovableColumns={true}
                            suppressMoveWhenColumnDragging={true}

                            // alwaysShowHorizontalScroll={true}
                            suppressHorizontalScroll={false} // Đảm bảo thanh cuộn ngang không bị ẩn
                            scrollbarWidth={13}
                            // suppressAutoSize={true}
                            // suppressColumnVirtualisation={true}
                            rowBuffer={10}
                        // onBodyScroll={onBodyScroll}
                        /> : <Box sx={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></Box>}
                    </div>
                    {
                        dataReady && dataRaw && dataRaw.map((item: any, index) => { //rowVirtualVisible
                            return (
                                <SymbolVirtualRow
                                    keyChange='CP'
                                    symbol={item?.symbol}
                                    key={index}
                                    applyTransactionAsyncRealtime={applyTransactionAsyncRealtime}
                                />
                            )
                        })
                    }
                </Box>
            </div>
        </div>
    )
}

export default HoldingsListSymbolRealtime
